<template>
    <v-form ref="formClientesAverbados" @submit.prevent v-model="validClienteAverbados">
        <v-container class="pt-0 telaAverbados">
            <div class="header-step">
                <h3>Clientes Averbados</h3>
                <p>Informe o nome dos principais clientes averbados.</p>
            </div>
            <v-container grid-list-lg class="pl-0">
                <v-layout row wrap>
                    <v-flex xs12 sm7 md7 lg5 xl4>
                        <v-text-field
                            :disabled="desabilitaBotao(clientesAverbados)"
                            label="Nome da empresa"
                            v-model="modelClientesAverbados.nomeEmpresa"
                            :error-messages="errorMessages.txtNomeEmpresa"
                        ></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm5 md5 lg3 xl2>
                        <v-text-field
                            :disabled="desabilitaBotao(clientesAverbados)"
                            label="Percentual da averbação"
                            v-model.lazy="modelFormatado.percentualAverbado"
                            type="number"
                            min="0"
                            max="100"
                            :error-messages="errorMessages.txtPercentualCliente"
                        ></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6 md6 lg4 xl3 text-xs-left class="pl-0">
                        <v-btn 
                            :disabled="desabilitaBotao(clientesAverbados)" 
                            @click="adicionarCliente"
                            :block="$vuetify.breakpoint.xsOnly"
                            class="white--text"
                            color="secondary"
                        >
                            ADICIONAR
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg4 xl3 text-xs-right>
                        <span>Total: {{totalFrequencia(clientesAverbados) ? totalFrequencia(clientesAverbados) : 0}}/100%</span>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 sm12 md12 lg8 xl6>
                        <v-data-table 
                            :headers="cabecalhoGridClientes"
                            :items="clientesAverbados"
                            hide-actions
                            no-data-text="Nenhum cliente foi adicionado" 
                        >
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.item.nomeEmpresa }}</td>
                                <td class="text-xs-left">{{ toPercentString(props.item.percentual) }}</td>
                                <td><v-btn :disabled="disableClientesAverbados" @click.stop="removeCliente(props.item)" color="primary remove-cliente" flat icon><v-icon>delete</v-icon></v-btn></td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs4 md3 class="pl-0">
                        <v-btn
                            flat
                            @click="$emit('voltarClientesAverbados', true)"
                            color="primary"
                        >
                            Voltar
                        </v-btn>
                    </v-flex>
                    <v-flex xs4 md3>
                        <v-btn
                            :disabled="totalPercentual(clientesAverbados)" 
                            type="submit"
                            @click="sendDatatoParent"
                            color="primary"
                        >
                            proximo
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-container>
    </v-form>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'

export default {
    name: 'ClientesAverbados',
    props: {
        protocolo: String,
        dadosQuestionarioCompleto: {
            type: Object, 
            required: false
        }
    },
    data: () => {
        return {
            validClienteAverbados: true,
            clientesAverbados: [],
            modelClientesAverbados: {
                nomeEmpresa: '',
                percentual: 0
            },
            modelFormatado: {
                percentualAverbado: 0
            },
            errorMessages: {
                txtNomeEmpresa: [],
                txtPercentualCliente: []
            },
            cabecalhoGridClientes: [
                {text: 'Nome da empresa', value: 'nomeEmpresa'},
                {text: 'Percentual', value: 'percentual'},
                {text: '', value: ''}
            ],
            regras: {
                notNull: [v => !!v || "Você não pode deixar este campo em branco"],
                percentual: [
                    v => (v >= 0) || 'Você precisa informar um valor válido',
                    v => (v <= 100) || 'Você precisa informar um valor válido',
                ],
            },
            percentualTotal: null,
            validaBotaoProximo: true
        }
    },
    computed: {
        disableClientesAverbados() {
            return this.protocolo != null || this.dadosQuestionarioCompleto.id != null;
        }
    },
    watch: {
        dadosQuestionarioCompleto(value) {
           
           if(value.id != null  &&  value.id != undefined) {
               for(var cliente of value.dadosOperacionais.averbados ) {
                   this.clientesAverbados.push({
                       nomeEmpresa: cliente.nomeEmpresa,
                       percentual: cliente.percentual
                   })
               }
           }
       },
        totalFrequencia: {
            handler: function () {
                this.totalFrequencia()
            },
            deep: true
        },
        'modelFormatado.percentualAverbado': function (val) {
            this.modelClientesAverbados.percentual = CustomFormat.removePercentFormat(val);
        }
    },
    methods: {
        sendDatatoParent() {      
            this.$emit("dadosClientesAverbados", this.clientesAverbados);
        },
        desabilitaBotao(clientesAverbados) {
            let valorTotal = 
            clientesAverbados.reduce((acc, cur) => acc + (parseInt(cur.percentual) || 0), 0);
            if(valorTotal == 100) {
                return true
            }
            return false
        },
        limparCamposClientes() {
            this.modelClientesAverbados.nomeEmpresa = '';
            let somaRotas = this.somaPercentual(this.clientesAverbados);
            this.modelFormatado.percentualAverbado = (100 - somaRotas).toLocaleString('pt-BR');
        },
        validAddCliente() {
            let erro = false;

            this.errorMessages.txtNomeEmpresa = [];
            if (Object.keys(this.modelClientesAverbados.nomeEmpresa).length === 0) {
                erro = erro || true;
                this.errorMessages.txtNomeEmpresa = ["Você não pode deixar este campo em branco"]
            }

            this.errorMessages.txtPercentualCliente = [];
            if (this.modelClientesAverbados.percentual <= 0 || this.modelClientesAverbados.percentual > 100) {
                erro = erro || true;
                this.errorMessages.txtPercentualCliente = ["Você precisa informar um percentual válido"]
            } else if ( isNaN(this.modelClientesAverbados.percentual) ) {
                erro = erro || true;
                this.errorMessages.txtPercentualCliente = ["Você precisa informar um percentual válido"]
            } else if (this.somaPercentual(this.clientesAverbados) + this.modelClientesAverbados.percentual > 100) {
                erro = erro || true;
                this.errorMessages.txtPercentualCliente = ["O percentual ultrapassa os 100 % com este valor"]
            }
            return !erro;
        },
        adicionarCliente() {
            if (this.validAddCliente()) {
                this.clientesAverbados.push(Object.assign({}, this.modelClientesAverbados));
                this.limparCamposClientes();
            }
        },
        removeCliente (item) {
            const index = this.clientesAverbados.indexOf(item);
            this.clientesAverbados.splice(index, 1);
        },
        
        totalFrequencia(modelClientesAverbados) { 
            return modelClientesAverbados.reduce((acc, cur) => acc + (parseInt(cur.percentual) || 0), 0);
        },
        somaPercentual: function (array) {
            if (array.length > 0) {
                let percentuais = array.map(x => { return x.percentual; });
                let soma = percentuais.reduce((a, b) => { return a + b });
                return soma;
            }
            return 0;
        },
        toPercentString: function (val) {
            return CustomFormat.toPercentString(val);
        },
        totalPercentual(clientesAverbados) {
            let percentual = 
            clientesAverbados.reduce((acc, cur) => acc + (parseInt(cur.percentual) || 0), 0);
            if ((percentual > 0 && percentual < 100) || percentual > 100) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style>
.telaAverbados{
    margin-top: 32px !important;
}
.totalFrequencia{
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARClientesAverbados.vue